<template>
  <div class="super-admin-dashboard__impressions-table">
    <h2>Impressions</h2>
    <div class="super-admin-dashboard__date-picker">
      <div
        class="super-admin-dashboard__period"
        @click="togglePeriod"
      >
        {{ currentPeriod }}
      </div>
      <chart-date-picker
        :date="currentDateString"
        :next-disabled="canSelectNextMonth"
        @next="changeDate(1, period)"
        @prev="changeDate(-1, period)"
      />
    </div>
    <advanced-table
      v-if="data.length"
      class="border-rounded"
      :columns="['Company', 'Impressions', 'Target', 'Remaining']"
      :data="data"
      :init-page-size="20"
    >
      <template #default="{ row }">
        <td class="horizontal">
          <company-icon :company="row.company" />
          <span class="company-name">
            {{ row.company.name }}
          </span>
        </td>
        <td>
          {{ Utils.parseImpressionCount(row.impressions) }}
        </td>
        <td>
          {{ Utils.parseImpressionCount(row.target) }}
        </td>
        <td
          :class="{
            'super-admin-dashboard__impressions-table-remaining--overspend':
              Math.abs(row.remaining) > 0
          }"
        >
          {{ Utils.parseImpressionCount(row.remaining) }}
        </td>
      </template>
    </advanced-table>
    <h3
      v-else
      class="text-center"
    >
      No data
    </h3>
  </div>
</template>
<script>
import CompanyIcon from "@/components/common/CompanyIcon.vue"
import Utils from "@/utils"
import ChartDatePicker from "@/components/dashboard/components/ChartDatePicker.vue"
import dayjs from "dayjs"
import { REPORTING_PERIOD_ANNUAL, REPORTING_PERIOD_MONTHLY } from "@/constants"

export default {
  components: { ChartDatePicker, CompanyIcon },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    period: {
      type: String,
      required: true
    },
    currentDate: {
      type: Object,
      required: true
    }
  },
  emits: ["change-date", "change-period"],
  computed: {
    Utils () {
      return Utils
    },
    currentDateString () {
      return this.period === REPORTING_PERIOD_MONTHLY
        ? this.currentDate.format("MMM YYYY")
        : this.currentDate.format("YYYY")
    },
    canSelectNextMonth () {
      return this.currentDate.clone().add(1, this.period) > dayjs()
    },
    currentPeriod () {
      return this.period === REPORTING_PERIOD_MONTHLY ? "Monthly" : "Annual"
    }
  },
  methods: {
    changeDate (value, type) {
      const newDate = dayjs(this.currentDate.format("YYYY-MM-DD")).add(value, type)

      this.$emit("change-date", newDate)
    },
    togglePeriod () {
      this.$emit(
        "change-period",
        this.period === REPORTING_PERIOD_ANNUAL
          ? REPORTING_PERIOD_MONTHLY
          : REPORTING_PERIOD_ANNUAL
      )
    }
  }
}
</script>
